/** Warm-up STT windows: 0–5s, 5–10s, 10–15s (three 5-second clips). */
export const TRANSCRIPT_WINDOW_WARMUP_MS = [5000, 5000, 5000]

/** Steady-state window length after warm-up: 15–25s, 25–35s, … */
export const TRANSCRIPT_WINDOW_STEADY_MS = 10000

/**
 * Duration of the next independently-transcribed audio window.
 * @param {number} windowIndex - zero-based index of the window about to be recorded
 */
export function getTranscriptWindowMs(windowIndex) {
	const index = Number(windowIndex)
	if (!Number.isFinite(index) || index < 0) {
		return TRANSCRIPT_WINDOW_STEADY_MS
	}

	if (index < TRANSCRIPT_WINDOW_WARMUP_MS.length) {
		return TRANSCRIPT_WINDOW_WARMUP_MS[index]
	}

	return TRANSCRIPT_WINDOW_STEADY_MS
}
